import React from "react";
import { Trans, useTranslation } from "react-i18next";
import PageHeader from "components/common/PageHeader";
import { ExternalLink } from "components/common";
import EmbeddedDefenderApp from "./EmbeddedDefenderApp";
const DefenderApp = () => {
  const { t } = useTranslation("enterprise_integrations");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PageHeader, { title: t("microsoftdefender.app.title") }, /* @__PURE__ */ React.createElement("span", null, t("microsoftdefender.app.description")), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "microsoftdefender.app.requirements",
      components: {
        defenderLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://security.microsoft.com" })
      }
    }
  ), " ")), /* @__PURE__ */ React.createElement(EmbeddedDefenderApp, null));
};
export default DefenderApp;
